define("settings/components/plan-recommendation/option-card", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <label
    class={{concat-classes "cPR--optionCard" (if @isSelected "is--active")}}
    data-test-id="plan-recommendation-option"
    for={{@inputId}}
    ...attributes
  >
    <input
      checked={{@isSelected}}
      class="cPR--optionCard__input"
      data-test-id="plan-recommendation-option-input"
      id={{@inputId}}
      name={{@groupName}}
      type="radio"
      {{on "change" this.handleChange}}
    />
    <span class="cPR--optionCard__label">{{@label}}</span>
  </label>
  */
  {
    "id": "YE2eMo7L",
    "block": "[[[11,\"label\"],[16,0,[28,[37,0],[\"cPR--optionCard\",[52,[30,1],\"is--active\"]],null]],[24,\"data-test-id\",\"plan-recommendation-option\"],[16,\"for\",[30,2]],[17,3],[12],[1,\"\\n  \"],[11,\"input\"],[16,\"checked\",[30,1]],[24,0,\"cPR--optionCard__input\"],[24,\"data-test-id\",\"plan-recommendation-option-input\"],[16,1,[30,2]],[16,3,[30,4]],[24,4,\"radio\"],[4,[38,2],[\"change\",[30,0,[\"handleChange\"]]],null],[12],[13],[1,\"\\n  \"],[10,1],[14,0,\"cPR--optionCard__label\"],[12],[1,[30,5]],[13],[1,\"\\n\"],[13]],[\"@isSelected\",\"@inputId\",\"&attrs\",\"@groupName\",\"@label\"],false,[\"concat-classes\",\"if\",\"on\"]]",
    "moduleName": "settings/components/plan-recommendation/option-card.hbs",
    "isStrictMode": false
  });
  let OptionCardComponent = _exports.default = (_class = class OptionCardComponent extends _component2.default {
    /** Swallows the change event so a `{{fn}}`-bound value arrives as onSelect's only argument. */
    handleChange() {
      this.args.onSelect();
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "handleChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, OptionCardComponent);
});